var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full pr-6"},[_c('div',{staticClass:"block"},[_c('ApexChartGeneral',{attrs:{"options":_vm.getChartOptions(),"palette-color-index":_vm.paletteColorIndex}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }